module.exports = __webpack_public_path__ + "static/assets/82fa0d66d5e20320021f46d36003dda5.png";